/** @module Sourcing/SupplierRequestForm */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/def",
	"csi/form/Widget",
	"csi/service/nodeService",
	"csi/xml",
	"./SupplierRequestFormMixin",
	"Sourcing",

], function(declare, _, def, Widget, { resolveNodesWithDependencies, resolveNode, resolveNodes }, xml, SupplierRequestFormMixin, Sourcing) {

	return declare([Widget,SupplierRequestFormMixin], {

		// figure out if we are on Style or Material based on the controller
		_productType: function() {
			if (this.isCopy()) {
				return (this.getViewNode().RequestType == "DataPackageContainerType:Style") ? "Style" : "Material";
			}

			if (this.defView.getSource().m_action.classController == "Sourcing.NewFoodSupplierRequest") {
				return "Food";
			} else if (this.defView.getSource().m_action.classController == "Sourcing.NewFoodSKUSupplierRequest") {
				return "FoodSKU";
			} else if (this.defView.getSource().m_action.classController == "Sourcing.NewFormulatedMaterialSupplierRequest") {
				return "FormulatedMaterial";
			}

			return (this.defView.getSource().m_action.classController == "Sourcing.NewStyleSupplierRequest" ||
				this.defView.getSource().m_action.classController == "Sourcing.NewStyleBreadcrumbSupplierRequest" ? "Style" : "Material");
		},

		/** 
		 * @override
		 * Set initial Right Side Panel values
		*/
		_buildView: function() {
			this.inherited(arguments);

			this.rightWidget.useFoodSKUsNode(this._productType() === "FoodSKU");

			// initialize statistics
			this.rightWidgetProperties = {
				numSuppliers: 0,
				numFactories: 0,
				numQuotes: 0,
				numSamples: 0,
				numProducts: 0,
				numFoodSKUs: 0
			},
			this._updateStatistics();
		},

		/**
		 * @override
		* Update right side with proper statistics on New and Copy
		*/
		_updateStatistics: function() {
			if (this.isCopy()) {
				this._updateCopyStatistics();
			} else if (this.isNew()) {
				this._updateNewStatistics();
			} else if (this.isEdit()) {
				this._updateEditStatistics();
			}
		},

		_updateCopyStatistics: async function() {
			var productField = this.getFieldValue(this._productType() + "s");
			var supplierField = this.getFieldValue(this.SUPPLIERS);
			var supplierFactoryField = this.getFieldValue(this.SUPPLIER_FACTORIES);
			var quoteField = this.getFieldValue(this.QUOTES);
			var sampleField = this.getFieldValue(this.SAMPLES);
			var productFieldLength = productField.length;
			var supplierFieldLength = this.getField(this.SUPPLIERS).m_typeControl === def.FIELD_MULTI_SELECT ? supplierField.length : (supplierField === "" ? 0 : 1);
			const supplierFactoryFieldLength = this.getField(this.SUPPLIER_FACTORIES).m_typeControl === def.FIELD_MULTI_SELECT ? (supplierFactoryField ? supplierFactoryField.length : 0) : (supplierFactoryField === "" ? 0 : 1);
			const supplierOrFactoryFieldLength = supplierFieldLength || supplierFactoryFieldLength;
			const supplierOrFactoryFieldValue = supplierFieldLength ? supplierField : supplierFactoryField;
			var extraSupplierFieldLength;
			var rightWidget = this.rightWidget;
			var quotes = 0;
			var prevQuotes = 0;
			var inspQuotes = 0;
			var samples = 0;
			var prevSamples = 0;
			var inspSamples = 0;
			rightWidget.set("numProducts", productFieldLength);
			rightWidget.set("numSuppliers", supplierFieldLength);
			rightWidget.set("numFactories", supplierFactoryFieldLength);

			var self = this;
			const templateNode = await resolveNode(this.getFieldValue(this.TEMPLATE), this.cacheView);
			var templateQuoteCt = (templateNode == null) ? 0 : templateNode.SRTQuotes.length;
			var sampQuantity = (templateNode == null || xml.enumGetText(templateNode.SampleType) == "") ? 0 : templateNode.SampleQuantity;
			if (productFieldLength > 0 && supplierFieldLength > 0 && self.statisticsMap) {
				// if there are inspiration Styles, just include the first one
				var productFieldWithoutDuplicateInspStyles = [];
				var onFirstInspirationStyle = true;
				_.each(productField, function(x) {
					var stats = self.statisticsMap[x];
					if (stats?.IsInspiration) {
						if (onFirstInspirationStyle) {
							productFieldWithoutDuplicateInspStyles.push(x);
							onFirstInspirationStyle = false;
						}
					} else {
						productFieldWithoutDuplicateInspStyles.push(x);
					}
				});

				const products = await resolveNodesWithDependencies(productFieldWithoutDuplicateInspStyles, ["Child:ProductSourcing/Child:ProductSources/Child:ColorSources"], this.cacheView);
				_.each(products, (product) => {
					var stats = self.statisticsMap[product.$URL];
					if (stats) {
						if (stats.IsInspiration) {
							inspQuotes += (templateNode ? templateQuoteCt : 1);
							inspSamples += (templateNode ? sampQuantity : 1);
						} else if (templateNode) {
							const isAllocationWIP = Sourcing.isProductColorwayAllocationWIP(product);
							var sampleOptions = xml.enumGetText(templateNode.SampleCreateOption);
							if (sampleOptions === "PerActiveColorway") {
								samples += this._countAllocatedColors(isAllocationWIP, product, supplierOrFactoryFieldValue, supplierOrFactoryFieldLength, sampQuantity);
							} else if (sampleOptions === "PerSize") {
								samples += stats.NumSizes;
							} else if (sampleOptions === "" || (sampleOptions === "DefaultColorSize" && stats.HasDefaultColorOrSize)) {
								samples++;
							}

							var quoteOptions = xml.enumGetText(templateNode.QuoteCreateOption);
							if (quoteOptions === "PerActiveColorway") {
								quotes += this._countAllocatedColors(isAllocationWIP, product, supplierOrFactoryFieldValue, supplierOrFactoryFieldLength, templateQuoteCt);
							} else if (quoteOptions === "PerSize") {
								quotes += stats.NumSizes;
							} else if (quoteOptions === "" || (quoteOptions === "PerTemplate" && stats.HasDefaultColorOrSize)) {
								quotes++;
							}
						}
					}
					extraSupplierFieldLength = 0;
					if (stats && !stats.IsInspiration) {
						_.each(supplierField, function(y) {
							if (stats.NumSamples[y] != null) {
								prevSamples += stats.NumSamples[y];
							}
							if (stats.NumQuotes[y] != null) {
								prevQuotes += stats.NumQuotes[y];
							}
							if (stats.NumSamples[y] == null && stats.NumQuotes[y] == null) {
								extraSupplierFieldLength++;
							}
						});
					}
				}, self);
				if (templateNode && quoteField === self.quoteSampleOptionPrevious) {
					let quoteOptions = xml.enumGetText(templateNode.QuoteCreateOption);
					if (quoteOptions === "PerActiveColorway") {
						rightWidget.set("numQuotes", prevQuotes + quotes + inspQuotes * supplierFieldLength);
					} else {
						rightWidget.set("numQuotes", prevQuotes + quotes * supplierFieldLength * templateQuoteCt + inspQuotes * supplierFieldLength);
					}
				} else if (templateNode) {
					let quoteOptions = xml.enumGetText(templateNode.QuoteCreateOption);
					if (quoteOptions === "PerActiveColorway") {
						rightWidget.set("numQuotes", quotes + inspQuotes * supplierFieldLength);
					} else {
						rightWidget.set("numQuotes", quotes * supplierFieldLength * templateQuoteCt + inspQuotes * supplierFieldLength);
					}
				} else if (quoteField === self.quoteSampleOptionPrevious) {
					rightWidget.set("numQuotes", prevQuotes + inspQuotes * supplierFieldLength);
				} else {
					rightWidget.set("numQuotes", inspQuotes * supplierFieldLength);
				}

				if (templateNode && sampleField === self.quoteSampleOptionTemplate) {
					let sampleOptions = xml.enumGetText(templateNode.SampleCreateOption);
					if (sampleOptions === "PerActiveColorway") {
						rightWidget.set("numSamples", samples + inspSamples * supplierFieldLength);
					} else {
						rightWidget.set("numSamples", samples * sampQuantity * supplierFieldLength + inspSamples * supplierFieldLength);
					}
				} else if (templateNode && sampleField === self.quoteSampleOptionPrevious) {
					let sampleOptions = xml.enumGetText(templateNode.SampleCreateOption);
					if (sampleOptions === "PerActiveColorway") {
						rightWidget.set("numSamples", prevSamples + samples + inspSamples * supplierFieldLength);
					} else {
						rightWidget.set("numSamples", prevSamples + samples * sampQuantity * extraSupplierFieldLength + inspSamples * supplierFieldLength);
					}
				} else if (sampleField === self.quoteSampleOptionPrevious) {
					rightWidget.set("numSamples", prevSamples + inspSamples * supplierFieldLength);
				} else {
					rightWidget.set("numSamples", inspSamples * supplierFieldLength);
				}

				if (templateNode && sampleField !== self.quoteSampleOptionPrevious) {
					self.setFieldValue(self.SAMPLETYPE, templateNode.SampleType);
				}
			} else {
				rightWidget.set("numSamples", 0);
				rightWidget.set("numQuotes", 0);
			}
		},

		_updateNewStatistics: async function() {
			const productField = this.getFieldValue(this._productType() + "s");
			const supplierField = this.getFieldValue(this.SUPPLIERS);
			const supplierFactoryField = this.getFieldValue(this.SUPPLIER_FACTORIES);
			const productFieldLength = productField ? productField.length : 0;
			const supplierFieldLength = this.getField(this.SUPPLIERS)?.m_typeControl === def.FIELD_MULTI_SELECT ? (supplierField ? supplierField?.length : 0) : (supplierField === "" ? 0 : 1);
			const supplierFactoryFieldLength = this.getField(this.SUPPLIER_FACTORIES)?.m_typeControl === def.FIELD_MULTI_SELECT ? (supplierFactoryField ? supplierFactoryField?.length : 0) : (supplierFactoryField === "" ? 0 : 1);
			const rightWidget = this.rightWidget;
			let quotes = 0;
			let samples = 0;
			let numSamplesPerActiveColor = 0;
			let numQuotesPerActiveColor = 0;
			rightWidget.set("numProducts", productFieldLength);
			rightWidget.set("numFoodSKUs", productFieldLength);
			rightWidget.set("numSuppliers", supplierFieldLength);
			rightWidget.set("numFactories", supplierFactoryFieldLength);

			const templateNode = await resolveNode(this.getFieldValue(this.TEMPLATE), this.cacheView);
			const templateQuoteCt = (templateNode == null) ? 0 : templateNode.SRTQuotes.length;
			const sampQuantity = (templateNode == null || xml.enumGetText(templateNode.SampleType) == "") ? 0 : templateNode.SampleQuantity;
			const supplierOrFactoryFieldLength = supplierFieldLength || supplierFactoryFieldLength;
			const supplierOrFactoryFieldValue = supplierFieldLength ? supplierField : supplierFactoryField;
			if (productFieldLength > 0 && supplierOrFactoryFieldLength > 0 && templateNode) {
				const sampleOptions = xml.enumGetText(templateNode?.SampleCreateOption);
				const quoteOptions = xml.enumGetText(templateNode?.QuoteCreateOption);
				let path = ["Child:ProductSourcing/Child:ProductSources/Child:ColorSources", "Child:ProductColors"];
				const products = await resolveNodesWithDependencies(productField, path, this.cacheView);
				_.each(products, (product) => {
					const isAllocationWIP = Sourcing.isProductColorwayAllocationWIP(product);
					if (sampleOptions === "PerActiveColorway") {
						numSamplesPerActiveColor += this._countAllocatedColors(isAllocationWIP, product, supplierOrFactoryFieldValue, supplierOrFactoryFieldLength, sampQuantity);
					} else if (sampleOptions === "PerSize") {
						samples += product.ProductSizes.length;
					} else if (sampleOptions === "DefaultColorSize") {
						const numProductSourcesWithDefaultColor = Sourcing.getCountProductSourcesWithDefaultColor(product, supplierOrFactoryFieldValue, this.cacheView);
						if (isAllocationWIP && xml.isValidURL(product.DefaultSize)) {
							samples += supplierOrFactoryFieldLength;
						} else if (isAllocationWIP && numProductSourcesWithDefaultColor) {
							samples += numProductSourcesWithDefaultColor;
						} else if (!isAllocationWIP && (xml.isValidURL(product.DefaultColor) || xml.isValidURL(product.DefaultSize))) {
							samples += supplierOrFactoryFieldLength;
						}
					} else if (sampleOptions === "") {
						samples++;
					}

					if (quoteOptions === "PerActiveColorway") {
						numQuotesPerActiveColor += this._countAllocatedColors(isAllocationWIP, product, supplierOrFactoryFieldValue, supplierOrFactoryFieldLength, templateQuoteCt);
					} else if (quoteOptions === "PerSize") {
						quotes += product.ProductSizes.length;
					} else if (quoteOptions === "PerTemplate") {
						const numProductSourcesWithDefaultColor = Sourcing.getCountProductSourcesWithDefaultColor(product, supplierOrFactoryFieldValue, this.cacheView);
						if (isAllocationWIP && xml.isValidURL(product.DefaultSize)) {
							quotes += supplierOrFactoryFieldLength;
						} else if (isAllocationWIP && numProductSourcesWithDefaultColor) {
							quotes += numProductSourcesWithDefaultColor;
						} else if (!isAllocationWIP && (xml.isValidURL(product.DefaultColor) || xml.isValidURL(product.DefaultSize))) {
							quotes += supplierOrFactoryFieldLength;
						}
					} else if (quoteOptions === "") {
						quotes++;
					}
				});
				if (sampleOptions === "PerActiveColorway") {
					// when samples per active color is selected, numSamples need to be used to account for multiple products which might contain
					// products which are both Allocated WIP or not Allocated WIP
					rightWidget.set("numSamples", numSamplesPerActiveColor);
				} else if (sampleOptions === "DefaultColorSize") {
					rightWidget.set("numSamples", samples * sampQuantity);
				} else {
					rightWidget.set("numSamples", samples * supplierOrFactoryFieldLength * sampQuantity);
				}

				if (quoteOptions === "PerActiveColorway") {
					// when samples per active color is selected, numQuotes need to be used to account for multiple products which might contain
					// products which are both Allocated WIP or not Allocated WIP
					rightWidget.set("numQuotes", numQuotesPerActiveColor);
				} else if (quoteOptions === "PerTemplate") {
					rightWidget.set("numQuotes", quotes * templateQuoteCt);
				} else {
					rightWidget.set("numQuotes", quotes * supplierOrFactoryFieldLength * templateQuoteCt);
				}
			} else {
				rightWidget.set("numSamples", 0);
				rightWidget.set("numQuotes", 0);
			}
		},

		_updateEditStatistics: async function() {
			let existingQuotes = 0;
			let existingSamples = 0;

			const cache = this.cacheView;
			const lineItems = await resolveNodes(this.getViewNode().LineItems, cache);
			productField = [];
			for (li of lineItems) {
				productField.push(li.SRLineItemProduct);
				existingQuotes += li.SRLineItemQuotes.length;
				existingSamples += li.SRLineItemSamples.length;
			}

			const supplierField = this.getFieldValue(this.SUPPLIERS);
			const productFieldLength = productField.length;
			var supplierFieldLength = this.getField(this.SUPPLIERS).m_typeControl === def.FIELD_MULTI_SELECT ? supplierField.length : (supplierField === "" ? 0 : 1);
			const supplierFactoryField = this.getFieldValue(this.SUPPLIER_FACTORIES);
			const supplierFactoryFieldLength = this.getField(this.SUPPLIER_FACTORIES).m_typeControl === def.FIELD_MULTI_SELECT ? (supplierFactoryField ? supplierFactoryField.length : 0) : (supplierFactoryField === "" ? 0 : 1);
			const rightWidget = this.rightWidget;

			let quotes = 0;
			let samples = 0;
			rightWidget.set("numProducts", productFieldLength);
			rightWidget.set("numSuppliers", supplierFieldLength);
			rightWidget.set("numFactories", supplierFactoryFieldLength);

			rightWidget.set("numSamples", 0);
			rightWidget.set("numQuotes", 0);

			const template = this.getViewNode().SRTemplate;
			if (xml.isValidURL(template)) {
				let path = ["Child:ProductColors"];
				const productsField = cache.getNodes(productField);
				const products = await resolveNodesWithDependencies(productsField, path, cache);
				this.when(cache.getNodeDeferred(template), function(templateNode) {
					const templateQuoteCt = (templateNode == null) ? 0 : templateNode.SRTQuotes.length;
					const sampQuantity = (templateNode == null || xml.enumGetText(templateNode.SampleType) == "") ? 0 : templateNode.SampleQuantity;
					_.each(products, function(product) {
						if (product) {
							const sampleOptions = xml.enumGetText(templateNode.SampleCreateOption);
							if (sampleOptions === "PerActiveColorway") {
								samples += (product.$Type == "Style" ? product.ActiveColorways.length :
									cache.getNodes(product.ProductColors).filter(n => n.Active).length); // have to filter manually
							} else if (sampleOptions === "PerSize") {
								samples += product.ProductSizes.length;
							} else if (sampleOptions === "" || (sampleOptions === "DefaultColorSize" && (xml.isValidURL(product.DefaultColor) || xml.isValidURL(product.DefaultSize)))) {
								samples++;
							}

							const quoteOptions = xml.enumGetText(templateNode.QuoteCreateOption);
							if (quoteOptions === "PerActiveColorway") {
								quotes += (product.$Type == "Style" ? product.ActiveColorways.length :
									cache.getNodes(product.ProductColors).filter(n => n.Active).length); // have to filter manually
							} else if (quoteOptions === "PerSize") {
								quotes += product.ProductSizes.length;
							} else if (quoteOptions === "" || (quoteOptions === "PerTemplate" && (xml.isValidURL(product.DefaultColor) || xml.isValidURL(product.DefaultSize)))) {
								quotes++;
							}
						}
					});

					rightWidget.set("numQuotes", quotes * supplierFieldLength * templateQuoteCt - existingQuotes);
					rightWidget.set("numSamples", samples * sampQuantity * supplierFieldLength - existingSamples);
					
				});
			}
		},

		/**
		 * Count number of allocated color product sources
		 */
		_countAllocatedColors: function(isAllocationWIP, product, supplierOrFactoryFieldValue, supplierOrFactoryFieldLength, quantity) {
			if (isAllocationWIP) {
				// if Product has Allocation WIP, only want to count colors that are in active colorProductSources
				let allocatedCPSColorsLength = Sourcing.getCountColorsInActiveCPSNoLineItem(product, supplierOrFactoryFieldValue, this.cacheView);
				// numSamples just count for colors in allocated CPS
				return allocatedCPSColorsLength * quantity;
			} else {
				return (product.$Type == "Style" ? 
						product.ActiveColorways.length :
						this.cacheView.getNodes(product.ProductColors).filter(n => n.Active).length) * quantity * supplierOrFactoryFieldLength; // have to filter manually
			}
		},
	});
});
